export { default as RepechageModel } from './staticModel'
